
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.991 10.03c-.441 0-.861-.19-1.152-.52L.298 2.074A1.23 1.23 0 012.147.449L7.866 6.95a.167.167 0 00.25 0l5.72-6.501a1.232 1.232 0 011.887 1.582l-.038.044-6.539 7.432a1.54 1.54 0 01-1.155.522z"}})])
          )
        }
      }
    